import { Injectable, signal } from '@angular/core';

@Injectable()
export class PolicyContainerService {
	public readonlyMode = signal(false);
}